import { Select } from '@coolblue-development/freddy';
import React, { useState, useEffect } from 'react';
import { AudioDevice } from './Settings';

interface SelectOptionProps {
  name: string;
  devices: AudioDevice[];
  label: string;
}

const SelectOption: React.FC<SelectOptionProps> = ({ name, devices, label }) => {
  const [selectedDevice, setSelectedDevice] = useState<string>('default');

  const handleDeviceChange = (event: React.ChangeEvent<HTMLSelectElement>): void => {
    const selectedDeviceId = event.target.value;
    setSelectedDevice(selectedDeviceId);

    connect.agent(agent => {
      switch (name) {
        case 'Microphone':
          agent.setMicrophoneDevice(selectedDeviceId);
          break;
        case 'Ringer':
          agent.setRingerDevice(selectedDeviceId);
          break;
        case 'Speaker':
          agent.setSpeakerDevice(selectedDeviceId);
          break;
        default:
          break;
      }
    });

    localStorage.setItem(name, selectedDeviceId);
  };

  useEffect(() => {
    const savedDeviceId = localStorage.getItem(name);
    if (savedDeviceId) {
      setSelectedDevice(savedDeviceId);
    }
  }, [name]);

  return (
    <Select
      label={label}
      value={selectedDevice}
      onChange={handleDeviceChange}
      data-testid="device-select"
      fullWidth
      sx={{ marginBottom: '10px' }}
    >
      {devices.map(device => (
        <option key={device.deviceId} value={device.deviceId}>
          {device.label}
        </option>
      ))}
    </Select>
  );
};

export default SelectOption;
